import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { customerShipmentsList } from "../../actions/shipmentNPayment";
import Table from "../../common/Table";
import { NavWrap, TableWrap } from "../ShopForTyres";

import { ship_status_text } from "../Orders/ShipmentDetails";
import moment from "moment";
import { useState } from "react";
import json2csv from "json2csv";
import { saveAs } from "file-saver";
import { DownloadOutlined } from "@ant-design/icons";

const Orders = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const shipment_list = useSelector(
    (state) => state?.shipNPay?.customer_shipments_list
  );
  const [dates, setDates] = useState({});
  const [filters, setFilters] = useState({});
  const [tableScroll, setTableScroll] = useState({ x: "100%" });

  useEffect(() => {
    const screenWidth = window.screen.width;
    const newScroll = screenWidth > 2200 ? { x: "100%" } : { x: 2200 };
    setTableScroll(newScroll);
  }, []);
  useEffect(() => {
    if (dates.start_date && dates.end_date) {
      dispatch(
        customerShipmentsList({
          email: localStorage.getItem("email"),
          ...dates,
          ...filters,
        })
      );
    } else {
      if (!dates.start_date && !dates.end_date) {
        dispatch(
          customerShipmentsList({
            email: localStorage.getItem("email"),
            ...filters,
          })
        );
      }
    }
    // eslint-disable-next-line
  }, [dates]);

  const Preshipstatus = {
    A: "Approved",
    S: "Auto Approved",
    P: "Pending Approval",
  };

  const columns = [
    // {
    //   header: "DO Number",
    //   accessor: "DeliveryNo",
    //   width: 8,
    // },
    {
      header: "Shipment ID",
      accessor: "ShipNo",
      width: 10,
    },
    {
      header: "Sales Order",
      accessor: "Sostring",
      width: 17,
    },
    {
      header: "Customer PO",
      accessor: "Custpostring",
      width: 17,
    },
    {
      header: "Delivered Quantity",
      accessor: "DeliveredQty",
      width: 10,
      cell: (row) => <span>{parseInt(row.DeliveredQty)}</span>,
    },
    {
      header: "Fill",
      accessor: "ZfillTot",
      width: 8,
      cell: (row) => <span>{parseFloat(row.ZfillTot).toFixed(3)}</span>,
    },
    {
      header: "ETD",
      accessor: "EtdDate",
      width: 8,
      cell: (row) => (
        <span>
          {row.EtdDate && !row.EtdDate?.includes("0000")
            ? moment(row.EtdDate, "YYYYMMDD").format("MM/DD/YY")
            : "-"}
        </span>
      ),
    },
    {
      header: "ETA",
      accessor: "EtaDate",
      width: 8,
      cell: (row) => (
        <span>
          {row.EtaDate && !row.EtaDate?.includes("0000")
            ? moment(row.EtaDate, "YYYYMMDD").format("MM/DD/YY")
            : "-"}
        </span>
      ),
    },
    {
      header: "Pre-shipment advice",
      accessor: "Preshipstatus",
      width: 15,
      cell: (row) => (
        <span className="text-btn">{Preshipstatus[row.Preshipstatus]}</span>
      ),
      className: "psa_status",
    },
    {
      header: "Shipment Status",
      accessor: "ShipStatus",
      width: 10,
      cell: (row) => (
        <span className="success-text">
          {ship_status_text[row.ShipStatus] || "Planning"}
        </span>
      ),
    },
    {
      header: "Shipment Origin",
      accessor: "Werkscrtyname",
      width: 10,
    },
    {
      header: "Delivery Address",
      accessor: "Street",
      width: 12,
      cell: (row) => (
        <span>
          {row.Street}, {row.City1}, {row.Country}
        </span>
      ),
    },
    {
      header: "Container No",
      accessor: "Container",
      width: 10,
    },
    {
      header: "Vessel Name",
      accessor: "VesselNo",
      width: 10,
    },
  ];

  return (
    <div className="shop-tyres">
      <NavWrap>
        <TableWrap
          isFilter={false}
          showBulk={false}
          name={"Pending Actions"}
          showGrid={false}
          searchPlaceholder={"Search by Sales Order,Customer PO,Shipment ID..."}
          isDateFilter={true}
          options={[{ label: "All Dates", value: "all" }]}
          label={""}
          total_count={shipment_list?.data?.pagination?.total_count}
          callSearch={(search) => {
            let obj = {
              email: localStorage.getItem("email"),
            };
            dispatch(
              customerShipmentsList({ ...obj, search_key: search, filter: "A" })
            );
            setFilters((f) => ({ ...f, search_key: search }));
          }}
          exportComponent={
            <button
              disabled={shipment_list?.loading || !shipment_list?.data?.length}
              onClick={() => {
                let prods = shipment_list?.data?.map((ele) => {
                  let obj = {};
                  columns?.forEach((itm) => {
                    if (["EtdDate", "EtaDate"]?.includes(itm.accessor)) {
                      obj[itm.header] =
                        ele[itm.accessor] && !ele[itm.accessor]?.includes("0000")
                          ? moment(ele[itm.accessor], "YYYYMMDD").format(
                              "MM/DD/YY"
                            )
                          : "-";
                    } else obj[itm.header] = ele[itm.accessor];
                  });
                  return obj;
                });
                let csv = json2csv.parse(prods);
                var blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
                saveAs(blob, "PendingActions.csv");
              }}
            >
              <DownloadOutlined color="#333" />
            </button>
          }
          onRangeChange={(val) => {
            let start_date = val?.[0] ? moment(val?.[0]) : null;
            let end_date = val?.[1] ? moment(val?.[1]) : null;
            if (val === null) {
              setDates({});
            } else {
              if (start_date && end_date) {
                setDates({
                  start_date,
                  end_date,
                });
              }
            }
          }}
          isRange={true}
          rangePlaceholder={["ETD Start date", "ETD End date"]}
          searchVal={filters.search_key || ""}
        >
          <Table
            columns={columns}
            data={shipment_list?.data?.filter?.(
              (ele) => ele?.Preshipstatus === "P"
            )}
            scroll={tableScroll}
            action={false}
            actionWidth={8}
            loading={shipment_list?.loading}
            onRowClick={(row) => {
              history.push("/shipment-detail", {
                do_number: row.DeliveryNo,
                shipment_no: row.ShipNo,
                isPending: row.Preshipstatus === "P",
              });
            }}
          />
        </TableWrap>
      </NavWrap>
    </div>
  );
};

export default Orders;
